import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const TransportParisPage = lazy(() => import('../pages/transport-paris/page'));
const DemenagementParisPage = lazy(() => import('../pages/demenagement-paris/page'));
const CoursierParisPage = lazy(() => import('../pages/coursier-paris/page'));
const LivraisonExpressParisPage = lazy(() => import('../pages/livraison-express-paris/page'));
const TransporteurExpressNanterrePage = lazy(() => import('../pages/transporteur-express-nanterre/page'));
const TransporteurPalettesRungisPage = lazy(() => import('../pages/transporteur-palettes-rungis/page'));
const AvisGooglePage = lazy(() => import('../pages/avis-google/page'));
const LaisserUnAvisPage = lazy(() => import('../pages/laisser-un-avis/page'));
const TemoignagesClientsPage = lazy(() => import('../pages/temoignages-clients/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const BlogTransportColisParisPage = lazy(() => import('../pages/blog/transport-colis-paris'));
const BlogChoisirTransporteurParisGuidePage = lazy(() => import('../pages/blog/choisir-transporteur-paris-guide'));
const BlogCoursierMotoVsUtilitairePage = lazy(() => import('../pages/blog/coursier-moto-vs-utilitaire'));
const BlogDemenagementConseilsParisPage = lazy(() => import('../pages/blog/demenagement-conseils-paris'));
const BlogLivraisonDernierKilometreParisPage = lazy(() => import('../pages/blog/livraison-dernier-kilometre-paris'));
const BlogTransportUrgentWeekendParisPage = lazy(() => import('../pages/blog/transport-urgent-weekend-paris'));
const AProposPage = lazy(() => import('../pages/a-propos/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/transport-paris',
    element: <TransportParisPage />,
  },
  {
    path: '/demenagement-paris',
    element: <DemenagementParisPage />,
  },
  {
    path: '/coursier-paris',
    element: <CoursierParisPage />,
  },
  {
    path: '/livraison-express-paris',
    element: <LivraisonExpressParisPage />,
  },
  {
    path: '/transporteur-express-nanterre',
    element: <TransporteurExpressNanterrePage />,
  },
  {
    path: '/transporteur-palettes-rungis',
    element: <TransporteurPalettesRungisPage />,
  },
  {
    path: '/avis-google',
    element: <AvisGooglePage />,
  },
  {
    path: '/laisser-un-avis',
    element: <LaisserUnAvisPage />,
  },
  {
    path: '/temoignages-clients',
    element: <TemoignagesClientsPage />,
  },
  {
    path: '/a-propos',
    element: <AProposPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/transport-colis-paris',
    element: <BlogTransportColisParisPage />,
  },
  {
    path: '/blog/choisir-transporteur-paris-guide',
    element: <BlogChoisirTransporteurParisGuidePage />,
  },
  {
    path: '/blog/coursier-moto-vs-utilitaire',
    element: <BlogCoursierMotoVsUtilitairePage />,
  },
  {
    path: '/blog/demenagement-conseils-paris',
    element: <BlogDemenagementConseilsParisPage />,
  },
  {
    path: '/blog/livraison-dernier-kilometre-paris',
    element: <BlogLivraisonDernierKilometreParisPage />,
  },
  {
    path: '/blog/transport-urgent-weekend-paris',
    element: <BlogTransportUrgentWeekendParisPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;